import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { MarketingContentImgPreview } from './MarketingContentImgPreview';

export interface MarketingContentPreviewProps {
  title: string;
  description: string;
  imageUrl?: string;
}

export const MarketingContentPreview: React.FC<MarketingContentPreviewProps> = ({
  title,
  description,
  imageUrl,
}) => (
  <Box display='flex' alignItems='center' maxWidth={240}>
    <MarketingContentImgPreview imageUrl={imageUrl} />
    <Box overflow='hidden' pl={2}>
      <Typography variant='subtitle2' component='p' gutterBottom noWrap>
        {title}
      </Typography>
      <Typography variant='caption' component='p' noWrap color='textSecondary'>
        {description}
      </Typography>
    </Box>
  </Box>
);
